import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/NotFound.css';

const NotFound = () => (
  <div className="not-found-container">
    <h1 className="not-found-title">404</h1>
    <h2 className="not-found-subtitle">Página não encontrada</h2>
    <p className="not-found-description">
      O endereço que você tentou acessar não existe ou foi movido.<br />
      Volte para a página inicial ou navegue pelo menu.
    </p>
    <Link to="/" className="not-found-button">
      Ir para Início
    </Link>
  </div>
);

export default NotFound;